module.exports = __webpack_public_path__ + "static/media/AppStore_US.2928664f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/design/img/AppStore_US.svg
// module id = 427
// module chunks = 0